import { IoTimeOutline } from 'react-icons/io5'

import { MdPhone, MdPlace } from 'react-icons/md'

export default function FooterAgencies ({ ...props })
{
	return (
		<ul className="c-footer__lieux">

			<li className="c-footer__lieux--info">

				<div className="c-footer__lieux--address">
					<p className="c-footer__lieux--info__title">
						Sotraf Capvern
					</p>
					<p>
						<MdPlace className="c-footer__lieux--info__ico" />
						129 Rue du Goutillou
					</p>
					<p>65130 Capvern</p>
				</div>

				<div className="c-footer__lieux--opening">

					<p className="c-footer__lieux--opening-text">
						<IoTimeOutline className="c-footer__items--ico" />
						Ouvert du lundi au vendredi
					</p>

					<p className="c-footer__lieux--opening-hours">
						8h30 à 12h30 et de 14h00 à 17h30
					</p>
				</div>

				<a href="tel:0562987574" className="c-footer__items--link-a">
					<MdPhone className="c-footer__items--ico" />
					05 62 98 75 74
				</a>

			</li>

			<li className="c-footer__lieux--info u-items-center">

				<div className="c-footer__lieux--address">
					<p className="c-footer__lieux--info__title">
						Sotraf Sarrancolin
					</p>
					{/* <p>
						<MdPlace className="c-footer__lieux--info__ico" />
						5 avenue de la gare
					</p>
					<p>65410 Sarrancolin</p> */}
				</div>

				{/* <div className="c-footer__lieux--opening">

					<p className="c-footer__lieux--opening-text">
						<IoTimeOutline className="c-footer__items--ico" />
						Ouvert du lundi au vendredi
					</p>

					<p className="c-footer__lieux--opening-hours">
						8h30 à 12h30 et de 14h00 à 17h30
					</p>
				</div> */}

				<a href="tel:0562987574" className="c-footer__items--link-a">
					<MdPhone className="c-footer__items--ico" />
					05 62 98 75 74
				</a>
			</li>

			<li className="c-footer__lieux--info">

				<div className="c-footer__lieux--address">
					<p className="c-footer__lieux--info__title">
						Sotraf Lannemezan
					</p>
					<p>
						<MdPlace className="c-footer__lieux--info__ico" />
						200 rue du huit mai 1945
					</p>
					<p>65300 Lannemezan</p>
				</div>

				<div className="c-footer__lieux--opening">

					<p className="c-footer__lieux--opening-text">
						<IoTimeOutline className="c-footer__items--ico" />
						Du mardi au dimanche
					</p>

					<p className="c-footer__lieux--opening-hours">
						9h30 à 12h30 et de 15h à 19h
					</p>
				</div>

				<a href="tel:0562390723" className="c-footer__items--link-a">
					<MdPhone className="c-footer__items--ico" />
					05 62 39 07 23
				</a>

			</li>

		</ul>
	);
}